import { AdditionalContact } from 'components/ProviderData/IpaAdministration/atoms/Models';

type TriggerWorkflowInput = Pick<AdditionalContact, 'isClaimAddress' | 'claimAddress' | 'claimAddress2'>;

/**
 * Determines whether saving a Claim Info record should trigger a PrintMemberIdCard approval workflow.
 *
 * Triggers when:
 * - The checkbox is checked AND (address changed OR checkbox was just checked)
 * - The checkbox was just unchecked (card will now fall back to the default Alignment address)
 */
export const shouldTriggerIdCardWorkflow = (data: TriggerWorkflowInput, contact: TriggerWorkflowInput): boolean => {
    if (data.isClaimAddress) {
        return (
            data.claimAddress !== contact.claimAddress ||
            data.claimAddress2 !== contact.claimAddress2 ||
            !contact.isClaimAddress
        );
    }
    return !!contact.isClaimAddress;
};
